export { StateConsumerSingleton as default };

/**
* Saves data in memory until it is consumed
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class StateConsumer {
  /**
   * State Data
   *
   * @public
   *
   * @type {Object}
   *
   * @since 7.0.0
   */
  data = {};

  /**
   * Sets an item in the State service if key does not exist
   *
   * @since 7.0.0
   *
   * @param {string} key  data key
   * @param {mixed}  data data to be storage
   *
   * @return {boolean}
   */
  set(key, data) {
    if (this.data[key]) {
      return false;
    }

    this.data[key] = data;
  }

  /**
   * Consumes the value of an item  stored in the state manager and deletes it's key
   *
   * @since 7.0.0
   *
   * @param {string} key           data key
   * @param {mixed}  default_value default value
   *
   * @return {void}
   */
  consume(key, default_value = null) {
    let value = this.data[key] || default_value;
    delete this.data[key];
    return value;
  }

  /**
   * Deletes the value of an item  stored in the state manager and deletes it's key
   *
   * @since 7.0.0
   *
   * @param {string} key           data key
   *
   * @return {void}
   */
  delete(key)  {
    delete this.data[key];
  }

  /**
   * Returns the value of an item stored without deleting it
   *
   * @since 7.0.0
   *
   * @param {string} key           data key
   * @param {mixed}  default_value retieves
   *
   * @return {void}
   */
  peek(key, default_value = null) {
    return this.data[key] || default_value;
  }
}

const StateConsumerSingleton = new StateConsumer();